document.addEventListener('DOMContentLoaded', function () {
  const host = window.location.hostname;

  // Standardwerte für Fallback
  let currentFlag = 'de';
  let currentCode = 'DE';

  // Domainbasierte Spracherkennung
  if (host.includes('casa-moro.nl')) {
    currentFlag = 'nl';
    currentCode = 'NL';
  } else if (host.includes('moroccan-furniture.co.uk')) {
    currentFlag = 'en';
    currentCode = 'EN';
  } else if (host.includes('casa-moro.eu')) {
    currentFlag = 'fi';
    currentCode = 'FI';
  } else if (host.includes('casa-moro.fr')) {
    currentFlag = 'fr';
    currentCode = 'FR';
  } else if (host.includes('el.coso-moro.shop')) {
    currentFlag = 'gr';
    currentCode = 'GR';
  } else if (host.includes('casa-moro.it')) {
    currentFlag = 'it';
    currentCode = 'IT';
  } else if (host.includes('casa-moro.net')) {
    currentFlag = 'pl';
    currentCode = 'PL';
  } else if (host.includes('casa-moro.es')) {
    currentFlag = 'es';
    currentCode = 'ES';
  } else if (host.includes('casa-moro.info')) {
    currentFlag = 'se';
    currentCode = 'SE';
  }

  const dropdowns = document.querySelectorAll('.custom-language-dropdown');

  dropdowns.forEach(dropdown => {
    const selected = dropdown.querySelector('.selected-option');
    const options = dropdown.querySelector('.language-options');

    if (!selected || !options) return;

    // ✅ Fallback-Schutz bei leerem Flag/Code
    const fallbackFlag = 'de';
    const fallbackCode = 'DE';

    const flag = currentFlag || fallbackFlag;
    const code = currentCode || fallbackCode;

    const flagPath = `https://coso-moro.shop/cdn/shop/t/22/assets/${flag}.svg`;
    selected.innerHTML = `<img src="${flagPath}" alt="${code}"> <span>${code}</span>`;

    // ⬇️ Dropdown öffnen/schließen
    selected.addEventListener('click', function (e) {
      e.stopPropagation();
      options.classList.toggle('show');
    });

    // 🔁 Sprachwechsel
    options.querySelectorAll('li').forEach(option => {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        const code = option.textContent.trim();
        const img = option.querySelector('img')?.getAttribute('src') || '';
        const url = option.getAttribute('data-url');

        selected.innerHTML = `<img src="${img}" alt="${code}"> <span>${code}</span>`;
        options.classList.remove('show');

        if (url) {
          window.location.href = url + '?force_reload=true';
        }
      });
    });

    // ❌ Klick außerhalb → Menü schließen
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        options.classList.remove('show');
      }
    });
  });
});
